import classNames from 'classnames'
import { FunctionComponent, HTMLProps, ReactNode } from 'react'

type Props = HTMLProps<HTMLButtonElement> & {
  children?: ReactNode
  icon?: ReactNode
  secondary?: boolean
  large?: boolean
}

export const Button: FunctionComponent<Props> = (props) => {
  const { className, children, icon, secondary, disabled, large, ...rest } =
    props
  return (
    <button
      {...rest}
      type="button"
      className={classNames(
        'border rounded inline-flex space-x-2 items-center transition-all',
        {
          'bg-white shadow-sm text-slate-800 border-gray-300 hover:bg-slate-50 font-medium':
            secondary,
          'bg-indigo-700 border-indigo-800 text-white font-semibold':
            !secondary,
          'opacity-50 pointer-events-none': disabled,
          'active hover:bg-opacity-90': !disabled,
          'text-sm py-2 px-4': !large,
          'text-base py-2.5 px-5': large,
        },
        className
      )}
    >
      {children && <span>{children}</span>}
      {icon && icon}
    </button>
  )
}
